"use strict";
exports.__esModule = true;
var angular = require("angular");
var so_rich_text_box_component_1 = require("../../../../../../components/so-rich-text-box/so-rich-text-box.component");
angular.module('smartorg.r6.mgmts.legalMessage', [
    so_rich_text_box_component_1["default"],
]);
require('./legal-message-display-directive');
require('./legal-message-manage-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.legalMessage';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/legal-message/app/js/plumbing/app.js